import React, { Component } from 'react';
import PropTypes from 'prop-types';
let DatePicker = require('react-datepicker').default;
let moment = require('moment');
import DateTimeHelper from 'infrastructure/js/utils/dateTimeHelper';
import Popover from '../Popover/popover';

require('./dateTimePickerOverlayEditor.scss');


export default class DateTimePickerOverlayEditor extends Component {

  constructor(props) {
    super(props);


    let selectedDate = props.value
      ? DateTimeHelper.ConvertToDate(props.value)
      : props.initialDate || null;

    this.state = {
      editMode: false,
      selectedDate: selectedDate
    };

  }


  onEntered = () => {
    this.setState({ editMode: true });
    document.addEventListener('click', this.handleTimeClick, true);
  };
  onExited = () => {
    this.setState({ editMode: false });
    document.removeEventListener('click', this.handleTimeClick, true);
  };

  
  
  handleTimeClick = (e) => {
  
    // look for the time-item class
    if (e.target.classList.contains('react-datepicker__time-list-item')) {
  
      // wait a tick for React-datepicker’s onChange to update state
      setTimeout(() => {
        let selectedDate = this.state.selectedDate;
        let formatted = DateTimeHelper.ConvertFromDate(selectedDate);
        
        this.handleSubmit(formatted);

      }, 0);
      
    }
  };



  convertToMomentObject = (date) => {
    let dFormat = DateTimeHelper.getDateTimeFormat();
    return moment(date, dFormat, DateTimeHelper.getUserOrgLocale(), true).utcOffset(0, true);
  };



  handleChange = (date) => {
    this.setState({ selectedDate: date });
  };



  onKeyDown = (e) => {
    if (e.keyCode === 46 || e.keyCode === 8) { //'Delete' or 'Backspace
      this.handleSubmit(null);
    }
  };

  handleSubmit = (data) => {
    if (this.props.handleSubmit) {
      let submitData = {};
      submitData.fieldName = this.props.name;
      submitData[this.props.name] = data;

      this.props.handleSubmit(submitData);
    }

    // close Popover
    document.body.click();
  };

  renderInput = (editableClassName) => {
    return (
      <div className={`datepicker-label ${editableClassName}`}>
        <input type="text" value={DateTimeHelper.FormatDateObjectToDayMonthTime(this.props.value)} onKeyDown={this.onKeyDown} readOnly={true} />
        {this.props.alert}
      </div>
    )
  };

  getPopoverComponent = () => {

    let tFormat = DateTimeHelper.getTimeFormat();
    let dFormat = DateTimeHelper.getDateFormat();

    return (
      <div>
        <div className="pl-datepicker-overlay pl-datetimepicker-overlay">
          <DatePicker
            inline
            fixedHeight
            locale={DateTimeHelper.getUserOrgLocale()}
            dateFormat={dFormat}
            timeFormat={tFormat}
            timeIntervals={10}
            minDate={this.props.minDate ? this.props.minDate : null}
            showMonthDropdown
            showYearDropdown
            showTimeSelect={this.props.showTimeSelect}
            dropdownMode="select"

            selected={this.state.selectedDate}

            onChange={this.handleChange}


          > </DatePicker>


        </div>
      </div>
    )
  };


  render() {

    let editableClassName = this.state.editMode ? 'editmode' : this.props.editable ? 'editable' : 'disabled';
    if (!this.props.editable) {
      return this.renderInput(editableClassName)
    }

    return <Popover
      popoverId='datetimepicker-overlay'
      className='datetimepicker-overlay'
      trigger="click"
      placement={this.props.placement}
      onEnter={this.onEntered}
      onExit={this.onExited}
      popoverTitle=''
      popoverComponent={this.getPopoverComponent()}
    >
      {this.renderInput(editableClassName)}

    </Popover>
  }
}

DateTimePickerOverlayEditor.defaultProps = {
  placement: 'bottom',
  editable: true
};
DateTimePickerOverlayEditor.propTypes = {
  placement: PropTypes.string,
  editable: PropTypes.bool,
};
